const AddressSelectionCollapsed = [{ span: 8, height: "42px", classes: "marginTop-48" }]

export default AddressSelectionCollapsed
